module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "container--fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Instagram Post URL",
      "placeholder": "e.g. https://www.instagram.com/p/abcdefghijklm/",
      "outlined": "",
      "color": "yellow darken-3"
    },
    model: {
      value: (_vm.igUrl),
      callback: function($$v) {
        _vm.igUrl = $$v
      },
      expression: "igUrl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.analyse(_vm.igUrl)
      }
    }
  }, [_vm._v("Analyse\n            ")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "hidden",
      "id": "viewModalIdDisplay",
      "data-toggle": "modal",
      "data-target": _vm.viewModalIdDisplay
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("History")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "striped": "",
      "bordered": "",
      "hover": "",
      "responsive": "",
      "headers": _vm.fields,
      "items": _vm.items
    },
    scopedSlots: _vm._u([{
      key: "item.instagram",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', [_c('a', {
          attrs: {
            "href": item.instagram,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.instagram))])])]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', [_c('v-btn', {
          attrs: {
            "small": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              return _vm.view(item)
            }
          }
        }, [_vm._v("\n                View\n              ")])], 1)]
      }
    }], null, true)
  })], 1)], 1)], 1), _vm._v(" "), _c('content-analysis-result-modal', {
    attrs: {
      "modalId": _vm.contentAnalysisResultModal,
      "postData": _vm.postAnalytics
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1d5e5f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ContentAnalysis/index.vue
// module id = 2306
// module chunks = 0